import React, { useState, useEffect } from 'react'
import CustomizedDialogs from '../../../../common/components/CustomDialog'
import ModuleRow from './ModuleRow'
import { Box } from '@mui/material'

export default function ModalTrainingModules({
  setActiveModulesArray,
  input,
  isShowing,
  onClose,
  modulesList,
  trainingId
}) {
  const [localActiveModules, setLocalActiveModules] = useState([])

  useEffect(() => {
    if (isShowing && modulesList) {
      const currentValue = Array.isArray(input.value) ? input.value : []
      const activeIds = modulesList
        .filter(module => currentValue.includes(module.trainingModuleId))
        .map(module => module.trainingModuleId)

      setLocalActiveModules(activeIds)
    }
  }, [isShowing, modulesList, input.value])

  useEffect(() => {
    if (!isShowing && localActiveModules.length > 0) {
      setActiveModulesArray(localActiveModules)
    }
  }, [isShowing, localActiveModules, setActiveModulesArray])

  const handleModuleChange = (moduleId, isActive) => {
    setLocalActiveModules(prev => {
      if (isActive && !prev.includes(moduleId)) {
        return [...prev, moduleId]
      } else if (!isActive && prev.includes(moduleId)) {
        return prev.filter(id => id !== moduleId)
      }
      return prev
    })
  }

  return (
    <CustomizedDialogs title={'Active Modules'} open={isShowing} handleClose={onClose}>
      <Box
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        gap={'8px'}
        height={'calc(60vh - 120px)'}
        sx={{
          '::-webkit-scrollbar': {
            width: '6px',
            height: '6px'
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: '#DBDBE6',
            borderRadius: '2px',
            '&:hover': {
              backgroundColor: '#DBDBE6'
            }
          },
          '::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
          scrollbarWidth: 'thin',
          scrollbarColor: '#DBDBE6 transparent'
        }}
        overflow={'auto'}
      >
        {modulesList?.map(module => {
          const currentValue = Array.isArray(input.value) ? input.value : []

          return (
            <ModuleRow
              setActiveModulesArray={handleModuleChange}
              input={input}
              key={module.trainingModuleId}
              name={module.module}
              type={module.type}
              id={module.trainingModuleId}
              active={currentValue.includes(module.trainingModuleId)}
              trainingId={trainingId}
            />
          )
        })}
      </Box>
    </CustomizedDialogs>
  )
}
